import React, { FC } from 'react'
import Carousel from 'components/SA/Carousel/v2'
import styles from 'apps/public/profile/artistProfile/components/artistProfile.module.scss'
import { useSelector } from 'react-redux'
import { getCollections } from 'apps/public/profile/artistProfile/selectors'
import SALink from 'components/SALink'
import { capitalizeString } from 'lib/helpers'
import useQA from 'hooks/useQA'
import { displayEllipticalString } from 'apps/public/profile/artistProfile/helpers'
const MAX_LENGTH = 65
const Component: FC = () => {
  const collections = useSelector(getCollections)
  const { testId } = useQA()
  if (!collections.length) {
    return null
  }
  return (
    <div className={styles.artistSeriesCarousel} {...testId('artist-series')}>
      <Carousel title='Artist Series'>
        {collections.map((item, index) => (
          <div key={index} className={styles.carouselItemWrapper}>
            <SALink href={item.collectionUrl} title={capitalizeString(item.title)}>
              <div key={index} className={styles.carouselItem}>
                <img src={item.artworkImage} className={styles.carouselImage} />
                <p className={styles.title}>
                  {displayEllipticalString(capitalizeString(item.title), MAX_LENGTH)}
                </p>
              </div>
            </SALink>
          </div>
        ))}
      </Carousel>
    </div>
  )
}

export default Component
